import React from 'react';
import { Typography, Row, Col, Card, Space, Divider, Image } from 'antd';
import { EnvironmentOutlined, MailOutlined, GlobalOutlined, HomeOutlined } from '@ant-design/icons';
import PageLayout from './PageLayout';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph, Link } = Typography;

const Contact = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <Card
        bordered={false}
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "48px",
          position: "relative",
          height: "400px",
        }}
        bodyStyle={{
          padding: 0,
          height: "400px",
          position: "relative",
        }}
      >
        <Image
          src="https://www.domuscavour.it/images/sampledata/tirano_autunno-6.jpg"
          alt="Contact header"
          preview={false}
          width="100%"
          height="400px"
          style={{
            objectFit: "cover",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Title level={1} style={{ color: "#fff", margin: 0 }}>
            {t('contactPage.title')}
          </Title>
        </div>
      </Card>

      <Row gutter={[48, 48]} align="middle" style={{ marginBottom: "48px" }}>
        <Col xs={24} md={12}>
          <Card
            bordered={false}
            style={{
              borderRadius: "12px",
              padding: "24px",
              height: "600px",
              overflow: "auto"
            }}
          >
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
              <Paragraph style={{ marginBottom: '8px' }}>
                {t('contactPage.intro')}
              </Paragraph>
              <Divider/>
              <div style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '12px' }}>
                <Space align="center" size={12}>
                  <EnvironmentOutlined style={{ fontSize: '22px', color: '#1890ff' }} />
                  <div>
                    <Title level={5} style={{ margin: 0 }}>{t('contactPage.address.title')}</Title>
                    <Paragraph style={{ margin: 0 }}>{t('contactPage.address.value')}</Paragraph>
                  </div>
                </Space>
              </div>
              
              <div style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '12px' }}>
                <Space align="center" size={12}>
                  <MailOutlined style={{ fontSize: '22px', color: '#1890ff' }} />
                  <div>
                    <Title level={5} style={{ margin: 0 }}>{t('contactPage.email.title')}</Title>
                    <Link href="mailto:info@cadecampo.com">{t('contactPage.email.value')}</Link>
                  </div>
                </Space>
              </div>
              
              <div style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '12px' }}>
                <Space align="center" size={12}>
                  <GlobalOutlined style={{ fontSize: '22px', color: '#1890ff' }} />
                  <div>
                    <Title level={5} style={{ margin: 0 }}>{t('contactPage.website.title')}</Title>
                    <Link href="https://cadecampo.com" target="_blank">{t('contactPage.website.value')}</Link>
                  </div>
                </Space>
              </div>
              
              <div style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '12px' }}>
                <Space align="center" size={12}>
                  <HomeOutlined style={{ fontSize: '22px', color: '#1890ff' }} />
                  <div>
                    <Title level={5} style={{ margin: 0 }}>{t('contactPage.airbnb.title')}</Title>
                    <Link href="https://airbnb.com/h/cadecampo" target="_blank">{t('contactPage.airbnb.value')}</Link>
                  </div>
                </Space>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card
            bordered={false}
            style={{
              borderRadius: "12px",
              overflow: "hidden",
            }}
            bodyStyle={{ padding: 0 }}
          >
            <iframe
              title="Ca' De Campo Location"
              width="100%"
              height="600px"
              style={{ border: 0 }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2760.809058392106!2d10.174443277391191!3d46.21425328308121!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4783bd9fe41beff5%3A0xf786744536503eb6!2sCa&#39;%20De%20Campo!5e0!3m2!1sen!2sit!4v1744214156861!5m2!1sen!2sit"
              allowFullScreen=""
              loading="lazy"
            />
          </Card>
        </Col>
      </Row>
    </PageLayout>
  );
};

export default Contact;
